import { createGlobalStyle } from 'styled-components';
import globalStyle from './globalStyle';
import reset from './reset';

import './fonts.css';

const GlobalStyle = createGlobalStyle`
    ${reset}
    ${globalStyle}
`;

export default GlobalStyle;
